<template>
  <div>
    <div class="grid-x grid-padding-y">
      <div class="large-12 cell">
        <p class="text-center">&nbsp;</p>
      </div>
    </div>
    <div class="grid-container container first">
      <div class="grid-x grid-padding-x layout">
        <div class="cell medium-6 large-4 large-centered">
          <div class="card-section">

            <div class="text-center h4">
                <router-link to="" style="color: inherit;">
                    Registration Failed!
                </router-link>
              </div>
              <div class="padding-top-1 padding-bottom-1">
<p style="font-size: 1rem;">
                    An error has ocurred, please contact admin.
                </p>
              </div>
          </div>
          <div class="callout">
            <p>
              Already have an account? Please login with your
              email and password.
            </p>
            <router-link :to="{name:'login'}"  class="h5 button radius">
              Login
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="container"></div>
  </div>
</template>

<script>

export default {
  name: "appRegisterValidateFail",
  mixins: [require("@/app/mixins/foundation")],
  props: ["uid", "code"],
  data() {
    return {
      model: {},
      isValid: false,
      loading: false,
      errored: false
    };
  },
  mounted () {
    window.scrollTo(0,0);
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
.layout {
  padding-top: 1.5rem;
  .large-centered {
    margin: 0 auto;
  }
}
.banner-description{
  background-image: linear-gradient(to bottom right, #cec9c9, white);
}
</style>
